import { AvailableCompanions } from "@hooks/use-companion";

const CompanionProfile = ({ type, children }) => {
  const companion = AvailableCompanions[type];
  if (!companion) return null;

  return (
    <div className="flex gap-md items-start mt-md">
      <img
        src={companion.headImage}
        alt={companion.displayName}
        className="w-16 h-16 rounded-full flex-shrink-0 bg-secondary object-cover"
      />
      <div className="flex-1 min-w-0">
        <h2 className="text-xl font-semibold text-primary">
          {companion.displayName}
        </h2>
        <p className="text-sm text-secondary">
          {companion.description}
        </p>
        <p className="text-secondary mt-sm">{children}</p>
      </div>
    </div>
  );
};

const CompanionHelp = () => {
  return (
    <div className="flex flex-1 flex-col h-full">
      <div className="rounded-large bg-primary flex flex-1 flex-col p-md overflow-hidden">
        <div className="flex flex-col flex-1 min-h-0 gap-sm overflow-y-auto overscroll-contain font-companion [&_h1]:font-companion [&_h2]:font-companion [&_p]:font-companion">
          <h1 className="text-2xl font-bold text-primary">
            What is Companion?
          </h1>
          <p className="text-secondary">
            Companions help you get more things done around
            Scribenote. They are powered by veterinary-trained AI and
            can help you with a variety of tasks to save you time.
          </p>
          <h1 className="text-2xl font-bold mt-sm text-primary">
            Meet Your Companions
          </h1>

          <CompanionProfile type="OTTO">
            Otto is your main companion and the one you chat with by
            default. He can answer general questions, and delegates to
            the specialists below when a task needs their expertise.
          </CompanionProfile>

          <CompanionProfile type="SUMMI">
            Summi is happy to help you summarize patient records,
            making it easier to understand the patient&apos;s history
            and get to caring for them faster and better. Simply
            upload the patient&apos;s records, and Summi will
            summarize them for you.
            <br />
            <br />
            You can also ask Summi questions about the patient&apos;s
            history, and she will answer them for you.
          </CompanionProfile>

          <CompanionProfile type="QUILL">
            Quill helps you edit notes and client summaries using
            natural language. Ask for changes like &ldquo;The plan is
            too detailed&rdquo; or &ldquo;Correct the misspelled
            medication names&rdquo;.
            <br />
            <br />
            Quill works best when you&apos;re viewing the note you
            want to edit (on Edit Note pages).
          </CompanionProfile>

          <CompanionProfile type="SAGE">
            Sage helps you answer tough questions by searching through
            high quality resources. Try asking questions like
            &ldquo;What is paroxysmal dyskinesia?&rdquo;
            <br />
            <br />
            Sage works slowly to find the most relevant information,
            so be patient!
          </CompanionProfile>
        </div>
      </div>
    </div>
  );
};

export default CompanionHelp;
